export default function addBoStartCity(info, setData, startCity, setIndex) {
    const index = startCity.indexOf(info.target.value);
    setIndex(index);
    setData(function (prevState) {
        return { ...prevState, [info.target.name]: info.target.value };
    });
}
